/**
 * @author NikolaV
 *
 * Different browsers may disable localStorage for different reasons (security, private mode)
 * Storage can also get full easily with 3D models caching
 * try/catch is best way to handle these cases
 */

export const LStorage = {
    getItem,
    getOrDefault,
    setItem,
    removeItem,
};

function getItem(key: string): string {
    try {
        return localStorage.getItem(key);
    }
    catch (e) {
        console.error(e);
        return null;
    }
}

function getOrDefault<T>(key: string, defaultValue: T): T {
    try {
        let val: any = localStorage.getItem(key);
        if (val !== null && val !== undefined && val != 'undefined' && (typeof defaultValue === 'boolean' || typeof defaultValue === 'number' || typeof defaultValue === 'object')) {
            val = JSON.parse(val);
        }
        return val === null ? defaultValue : val;
    }
    catch (e) {
        console.error(key, e);
        return defaultValue;
    }
}

function setItem(key: string, data: any): boolean {
    try {
        if (typeof data != 'string') {
            data = JSON.stringify(data);
        }
        localStorage.setItem(key, data);
        return true;
    }
    catch (e) {
        console.error(key, e);
        return false;
    }
}

function removeItem(key: string): boolean {
    try {
        localStorage.removeItem(key);
        return true;
    }
    catch (e) {
        console.error(key, e);
        return false;
    }
}
